/**
 * /channel-partner — the account's Channel Partner status: register,
 * complete an invitation, pending review, or the decision. Approved Channel
 * Partners are sent on to the Hub.
 */
import { createFileRoute } from '@tanstack/react-router';
import { ChannelPartnerStatusPage } from '@/features/channel-partner/components/status-page';

export const Route = createFileRoute('/_protected/channel-partner/')({
  component: ChannelPartnerStatusPage,
});
